<template>
  <div class="wa-step wa-step--intro">
    <h2 class="wa-step__heading">
      {{ t('storeParameters.services.whatsappBusinessParameter.notConnected.title') }}
    </h2>
    <p class="wa-step__lead">
      {{ t('storeParameters.services.whatsappBusinessParameter.notConnected.subtitle') }}
    </p>
    <h3 class="wa-step__subheading">
      {{ t('storeParameters.services.whatsappBusinessParameter.notConnected.benefitsTitle') }}
    </h3>
    <ul class="wa-step__benefits">
      <li
        v-for="(key, index) in benefitKeys"
        :key="index"
      >
        <i class="fa-solid fa-check-circle" />
        <span>{{ t(key) }}</span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'WhatsappIntroStep',

  setup() {
    const { t } = useI18n();
    const benefitKeys = [
      'storeParameters.services.whatsappBusinessParameter.notConnected.benefit1',
      'storeParameters.services.whatsappBusinessParameter.notConnected.benefit2',
      'storeParameters.services.whatsappBusinessParameter.notConnected.benefit3',
    ];
    return { t, benefitKeys };
  },
});
</script>
